export default "__VITE_ASSET__BAY_ZxxO__"